/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { graphql } from 'gatsby'
import _orderBy from 'lodash/orderBy'
import _size from 'lodash/size'
// Redux
import { loadFilter, setYear, setSort } from '~lib/saga/filter/actions'
// Containers
import Layout from '~containers/Layout'
// Components
import { ItemContainer } from '~components/ContainerCard'
import ContainerHeader from '~components/ContainerHeader'
import Seo from '~components/Seo'
// Utils
import { getSortByFilter, sortByFilters } from '~utils/sortByFilters'

const filterSelector = (state) => state.filter

const FandomCategory = ({ data, location, pageContext, path }) => {
  const dispatch = useDispatch()
  const {
    allMarkdownRemark: { edges },
  } = data

  const { categoryId, categoryTitle, year: yearContextPage } = pageContext
  const {
    data: {
      id: filterId,
      sort: filterSort,
      viewType: filterViewType,
      year: filterYear,
    },
  } = useSelector(filterSelector)

  if (categoryId !== filterId && _size(filterId) !== _size(categoryId)) {
    dispatch(loadFilter(categoryId))
  }

  if (yearContextPage !== filterYear) {
    dispatch(setYear(yearContextPage))
  }

  //   Handle sort query params
  useEffect(() => {
    if (
      window.location.pathname.includes('/2018/') ||
      window.location.pathname.includes('/2017/') ||
      !window.location.search
    ) {
      return
    }

    const sortParam = new URLSearchParams(
      window.location.search.substring(1)
    ).get('sort')

    if (
      !sortParam ||
      !sortByFilters.map((f) => f.id).some((el) => sortParam === el) ||
      'rank' === filterSort
    ) {
      return
    }

    if (sortParam !== filterSort) {
      dispatch(setSort(sortParam))
    }
  }, [dispatch, filterSort])

  const items = _orderBy(
    edges,
    [`node.frontmatter.${filterSort}`, 'node.frontmatter.rank'],
    [getSortByFilter(filterSort).sort]
  )

  return (
    <Layout page="Home">
      <Seo title={categoryTitle} path={location.pathname} />
      <ContainerHeader />
      <ItemContainer items={items} location={location} />
    </Layout>
  )
}

export const query = graphql`
  query ($categoryId: [String], $year: [Int]) {
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: { glob: "**/src/data/**/fandoms/*.md" }
        frontmatter: { categories: { in: $categoryId }, year: { in: $year } }
      }
      sort: { fields: frontmatter___rank, order: DESC }
      limit: 500
    ) {
      edges {
        node {
          id
          fields {
            allEntertainment
            allSports
            # brands
            celebrities
            college
            comics
            gaming
            mlb
            movies
            music
            nfl
            nhl
            other
            proBasketball
            soccer
            sportsFigures
            tv
            feature {
              html
              frontmatter {
                byLine
                dateCreated
                dateUpdated
                linkAttribution
                linkExternal
                nextToRank
                path
                title
                year
              }
            }
            hasFeature
          }
          frontmatter {
            categories
            categoryPrimary
            contentType
            dateCreated(formatString: "MMMM DD, YYYY")
            dateUpdated(formatString: "MMMM DD, YYYY")
            fanBuzz
            imageCard
            imageDetail
            imageSocial
            path
            rank
            searchScore
            socialFollowing
            title
            twitterHandle
            year
          }
        }
      }
    }
  }
`
export default FandomCategory
